<template>
  <div class="topicAdd">
    <el-card>
      <div class="add_box">
        <el-form
          :model="toEdDas"
          :rules="toEdRule"
          :label-position="labelPosition"
          ref="ruleForm"
        >
          <el-row>
            <el-col :span="10">
              <el-form-item label="活动名称" prop="activityName">
                <el-input
                  placeholder="请输入内容"
                  v-model="toEdDas.activityName"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="投票次数" prop="limitDay">
                <el-input
                  type="number"
                  placeholder="请输入内容"
                  v-model="toEdDas.limitDay"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="活动开始时间" prop="startDate">
                <el-date-picker
                  v-model="toEdDas.startDate"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="活动结束时间" prop="endDate">
                <el-date-picker
                  v-model="toEdDas.endDate"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="封面图" prop="coverUrl">
              <el-upload
                class="avatar-uploader"
                :auto-upload="true"
                :show-file-list="false"
                :on-success="TopicSuccess"
                :action="serverUrl"
                :headers="header"
                name="img"
              >
                <img
                  v-if="toEdDas.coverUrl"
                  :src="toEdDas.coverUrl"
                  class="avatar"
                />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 10px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="活动规则" prop="rule">
                <el-input
                  type="textarea"
                  :rows="10"
                  placeholder="请输入内容"
                  v-model="toEdDas.rule"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="活动介绍" prop="introduce">
                <el-input
                  type="textarea"
                  :rows="10"
                  placeholder="请输入内容"
                  v-model="toEdDas.introduce"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-button
              style="margin-left: 600px"
              type="primary"
              @click="submitEdit('ruleForm')"
              >保存</el-button
            >
          </el-row>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
import {baseURL} from '../../api/config'
export default {
  data() {
    return {
      labelPosition: "top",
      loadUpt: false,
      toEdDas: "",
      toEdRule: {
        activityName: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        startDate: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        endDate: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        introduce: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        rule: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        limitDay: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        coverUrl: [
          { required: true, message: "封面图不能为空", trigger: "blur" },
        ],
      },
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      //审核状态
      examStatus: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],
      backOpen: true,
    };
  },
  methods: {
    TopicSuccess(file, fileList) {
      this.toEdDas.coverUrl = file.entity;
    },
    //将中国标准时间转换为年月日格式  ----开始
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
    },
    // 修改
    submitEdit(formName) {
      var date2 = new Date(this.toEdDas.endDate);
      var endDate = this.formatDate(date2);
      this.toEdDas.endDate = endDate;
      var date = new Date(this.toEdDas.startDate);
      var startDate = this.formatDate(date);
      this.toEdDas.startDate = startDate;
      this.$refs[formName].validate((valid) => {
        this.postAxios("/vote/update", {
          id: this.toEdDas.id,
          activityName: this.toEdDas.activityName, //活动名称
          startDate: startDate, //活动开始时间
          endDate: endDate, //活动结束时间
          introduce: this.toEdDas.introduce, //活动介绍
          coverUrl: this.toEdDas.coverUrl, //封面图
          rule: this.toEdDas.rule, //活动规则
          limitDay: this.toEdDas.limitDay, //投票次数
        }).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
          } else if (res.success == false && res.statusCode == 401) {
            this.$router.push("/");
            this.$message.error(res.message);
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
  },
  props: ["Editdata"],
  created() {
    this.toEdDas = this.Editdata;
  },
  watch: {
    Editdata(newVal, oldVal) {
      this.toEdDas = this.Editdata;
    },
  },
};
</script>
<style scoped >
.add_box {
  width: 95%;
  height: 100%;
  margin: 0 auto;
}
.el-col-10 {
  margin-right: 32px;
}
.el-upload {
  width: 200px;
  height: auto;
}
.el-upload img {
  width: 200px;
  height: auto;
}
</style>